<ion-item
  mode="md"
  [color]="backgroundColor"
  lines="none"
  class="item-special-info-wrapper"
>
  <ion-icon
    [name]="iconName"
    [color]="iconColor"
    class="getm-special-info-icon"
    slot="start"
  ></ion-icon>
  <ion-text
    [color]="textColor"
    class="getm-special-info-text"
    [innerHtml]="text | htmlSeguro"
  ></ion-text>

  <ng-container *ngIf="variant === 'counter' && remainingTime">
    <ion-text slot="end" [color]="textColor" class="getm-special-info-time">
      {{ remainingTime }}
    </ion-text>
  </ng-container>

  <ng-container *ngIf="variant === 'button'">
    <section slot="end" class="getm-special-info-right">
      <getm-button
        [text]="buttonText"
        color="white"
        size="small"
        expand="block"
        (btnClick)="onButtonClick()"
      ></getm-button>
    </section>
  </ng-container>
</ion-item>
